"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mimeTypes = {
    png: 'image/png',
    gif: 'image/gif',
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    pjpeg: 'image/pjpeg',
    svg: 'image/svg+xml',
    ico: 'image/x-icon',
    txt: 'text/plain',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    fb: 'application/x-fictionbook+xml',
    fb2: 'application/x-fictionbook+xml',
    'fb2.zip': 'application/x-zip-compressed-fb2',
    odt: 'application/vnd.oasis.opendocument.text',
    sxw: 'application/vnd.sun.xml.writer',
    epub: 'application/epub+zip',
    woff: 'application/font-woff',
    woff2: 'application/font-woff2',
    csv: 'text/csv',
    tsv: 'text/tab-separated-values',
    tab: 'text/tab-separated-values',
    djvu: 'image/vnd.djvu',
    djv: 'image/vnd.djvu',
    zip: 'application/zip',
    rtf: 'application/rtf'
};
function lookup(filename) {
    if (!filename) {
        return undefined;
    }
    var preparedFilename = filename.toLowerCase();
    for (var extension in mimeTypes) {
        if (mimeTypes.hasOwnProperty(extension)) {
            var length_1 = extension.length;
            if (preparedFilename.slice(-length_1) === extension) {
                return mimeTypes[extension];
            }
        }
    }
}
exports.lookup = lookup;



//////////////////
// WEBPACK FOOTER
// ./node_modules/file2html-ooxml/node_modules/file2html/lib/mime.js
// module id = 665
// module chunks = 0